/**
 * Nombre y señas de la app, en un solo sitio para poder cambiarlos de golpe.
 *
 * Al renombrar la app, cambia esto y además, a mano (no pueden leer este
 * archivo): `public/index.html` (título), `public/manifest.webmanifest`,
 * `capacitor.config.ts` (appName), `ios/App/App/Info.plist` y el nombre en
 * App Store Connect. El logo vive en `src/components/Logo.tsx` y en
 * `public/marca/myarinn.svg` (de ahí salen los PNG de los iconos).
 * El identificador del paquete de iOS (appId) NO cambia con el nombre: es
 * permanente una vez publicada la app y nadie lo ve.
 */
export const NOMBRE_APP = 'myarinn';

/** Frase corta bajo el nombre en la pantalla de entrada. */
export const LEMA_APP = 'Todo lo de tu hogar, en un solo sitio';

/**
 * Dirección pública de la web. Hace falta para los enlaces que se comparten
 * (invitaciones de A medias): dentro de la app de iOS la página se sirve desde
 * `capacitor://localhost`, que no sirve para mandárselo a nadie.
 * Se fija con REACT_APP_URL_PUBLICA; sin ella, en la web vale la del navegador.
 */
export const DOMINIO = 'myarinn.app';

export const URL_PUBLICA: string =
  (process.env.REACT_APP_URL_PUBLICA || '').replace(/\/+$/, '')
  // En la app de iOS no hay «dirección del navegador» que valga: la de siempre
  || (window.location.protocol.startsWith('http') ? window.location.origin : `https://${DOMINIO}`);

/** Ficha de la app en la App Store (la de España; Apple redirige a la tienda de cada país). */
export const URL_APP_STORE = 'https://apps.apple.com/es/app/myarinn/id6824938911';

// ── Datos para la política de privacidad (/privacidad) ──────────────────────
// El RGPD obliga a decir quién es el responsable y cómo contactarle.

/** Quién responde de los datos. Si algún día publica una empresa, su razón social y NIF. */
export const RESPONSABLE_DATOS = 'Rubén Zamora Martínez';

/** Correo para ejercer derechos (acceso, borrado…) y dudas de privacidad. */
export const CONTACTO_PRIVACIDAD = 'rubenzamoraphoto@icloud.com';

/**
 * Dónde guarda Firestore los datos. Si se sabe la región (Firebase → Configuración
 * del proyecto → General → «Ubicación de recursos predeterminada»), conviene
 * concretarla, p. ej. «servidores de Google Cloud en la Unión Europea».
 */
export const UBICACION_DATOS = 'servidores de Google Cloud en Madrid, España (región europe-southwest1)';

/** Fecha de la última versión de la política. Cámbiala cada vez que la cambies. */
export const FECHA_PRIVACIDAD = '22 de octubre de 2026';
